import { OfferTransitions } from './enums';

export const ListingTableHeaders = ['Image', 'Title', 'Price', 'State', 'Date', 'Stock', 'Copy'];

export const ADD_ICON = 'addIcon';
export const ADD = 'add';
export const SUBTRACT = 'subtract';
export const SUBTRACT_ICON = 'subtractIcon';
export const DETAILS = 'details';
export const OTHER = 'other';
export const WEIGHT = 'weight';
export const EDIT = 'edit';

export const OFFER_ACCEPTED_TRANSITIONS = Object.freeze([
  OfferTransitions.ACCEPT_OFFER,
  OfferTransitions.ACCEPT_AFTER_COUNTER_1,
  OfferTransitions.ACCEPT_AFTER_COUNTER_2,
  OfferTransitions.ACCEPT_AFTER_COUNTER_3,
]);
export const MODAL_BREAKPOINT = 1023;
export const MOBILE_BREAKPOINT = 768;
export const IMAGE = 'image';

export const PAYPAL_MERCHANT_PAGE = '/account/paypal-merchant';
export const GB = 'GB';


export const EU_COUNTRIES = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
];